export default __webpack_public_path__ + "static/media/1213 cutlery side.a1f41f9a.png";